import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface ChevronLeftProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const ChevronLeft: React.FunctionComponent<React.PropsWithChildren<ChevronLeftProps>> = ({
    fill,
    title,
    height,
    width,
    ...rest
}): any => (
    <SVGBase viewBox="0 0 444.819 444.819" height={height} width={width} title={title} fill={fill} {...rest}>
        <path d="M92.793,196.712,278.934,10.848Q289.216,0,304.631,0t25.7,10.848l21.7,21.416a34.965,34.965,0,0,1,10.566,25.692,36.551,36.551,0,0,1-10.566,25.981L213.273,222.41,352.032,361.168A34.971,34.971,0,0,1,362.6,386.861a36.552,36.552,0,0,1-10.564,25.98l-21.7,21.413a36.536,36.536,0,0,1-51.394,0L92.793,248.39a36.555,36.555,0,0,1-10.571-25.981A34.969,34.969,0,0,1,92.793,196.712Z" />
    </SVGBase>
);

export default ChevronLeft;
